import { useState } from 'react'
import TableTab3 from "./TableTab3";
import {
  useItemTaxTemplateMutation,
  useItemTaxCategoryMutation,
} from "../../../../store/api/itemapi";
const Tab3 = ({ setselected_tax_item_data,list_itemtax_data,list_item_tax_category_data}) => {
  const [ItemTaxTemplateApi] = useItemTaxTemplateMutation();
  const [ItemTaxCategoryApi] = useItemTaxCategoryMutation();
  return (
   <div
      className="row mb-3"
      style={{ border: "1px solid #00000059", borderRadius: "5px" }}
    >
      <div className="col-12">
        <p className="boxLabel m-0">Item Tax</p>
      </div>
      
      
      
      <TableTab3 setselected_tax_item_data={setselected_tax_item_data} list_itemtax_data={ItemTaxTemplateApi} list_item_tax_category_data={ItemTaxCategoryApi}/>


    </div>
  )
}

export default Tab3